import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { Button } from "../Button/Button";
import { DateString } from "../DateString/DateString";
import { PreviousNextSlider } from "../PreviousNextSlider/PreviousNextSlider";
import styles from "./DateSlider.module.less";
import { generateTrackingId } from "client/Misc/utils";
import { addDays, getStartOfDay } from "client/DateAndTime/dateTimeUtils";
import { TimeZone } from "client/DateAndTime/timezones";
import { Space } from "../Space/Space";

export type DateSliderProps = {
	value: Date;
	onChange(value: Date): void;
	isTodayButtonAvailable?: boolean;
	trackingId?: string;
	timezone: TimeZone;
};

export const DateSlider = (props: DateSliderProps): ReactElement => {
	const {
		value,
		onChange,
		isTodayButtonAvailable,
		timezone,
		trackingId
	} = props;

	const changeDateHandler = (daysToAdd: number): void => {
		const newValue: Date = addDays(
			value,
			daysToAdd,
			timezone
		);
		onChange(newValue);
	};

	const todayHandler = (): void => {
		onChange(
			getStartOfDay(new Date(), timezone)
		);
	};

	return (
		<div className={styles.root}>
			{
				isTodayButtonAvailable && (
					<Button
						kind="secondary"
						text={localize("_Today")}
						onClick={todayHandler}
						trackingId={generateTrackingId(trackingId, "__today-button")}
					/>
			)}
			<div className={styles.previousNext}>
				<PreviousNextSlider
					onPrevious={() => changeDateHandler(-1)}
					onNext={() => changeDateHandler(1)}
					trackingId={generateTrackingId(trackingId, "__slider")}
				>
					<DateString
						value={value}
						format="DayName"
						timezone={timezone}
					/>
					,<Space />
					<DateString
						value={value}
						format="DM(Y)"
						timezone={timezone}
					/>
				</PreviousNextSlider>
			</div>
		</div>
	);
};
DateSlider.displayName = "DateSlider";
